import { AuthProvider, RequireAuth } from './contexts/AuthContext'
import { Dashboard } from './components/Dashboard'
import { Lobby } from './components/Lobby'
import { useAuth } from './contexts/AuthContext'

function AppContent() {
  const { isInLobby } = useAuth()
  
  if (isInLobby) {
    return <Lobby />
  }
  
  return <Dashboard />
}

export function App() {
  return (
    <AuthProvider>
      <RequireAuth>
        <AppContent />
      </RequireAuth>
    </AuthProvider>
  )
}